import React from 'react';
import { comabooksCoverById } from './catalog';
import './ComabooksCover.css';

export interface ComabooksCoverProps {
  /** id пресета (cb-<группа>-<цвет>). Неизвестный — дефолт cb-1-red. */
  coverId: string | null | undefined;
  title?: string;
  author?: string;
  /** Вторая строка под автором (имя партнёра/получателя). Пусто — не показывается. */
  receiver?: string;
  className?: string;
}

/**
 * Превью обложки 1:1 со старым клиентом Comabooks (ui-v2/pages/Cover):
 * картинка пресета + текстовый оверлей с отступами в % ширины. Размеры
 * шрифтов там были в px при ширине превью 200px — здесь они в cqw
 * (px / 2), чтобы превью масштабировалось без изменения пропорций.
 */
export const ComabooksCover: React.FC<ComabooksCoverProps> = ({
  coverId,
  title,
  author,
  receiver,
  className = '',
}) => {
  const entry = comabooksCoverById(coverId);
  return (
    <div className={`cbc ${className}`}>
      <div className="cbc__wrap">
        <img src={entry.preview} alt="" className="cbc__img" draggable={false} />
        <div className={`cbc__overlay cbc__overlay--g${entry.group}`}>
          <div className="cbc__title">{title || ' '}</div>
          <div className="cbc__names">
            <div className="cbc__author">{author || ' '}</div>
            <div className="cbc__partner">{receiver || ' '}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
